module.exports = __webpack_public_path__ + "img/tested.fcb62d5f.png";